import getConfig from "next/config"
import { useState } from "react"
import { LocationItem } from "types/location"

type LocationCardPreviewProps = {
    primary_color: string
    location: LocationItem
}

export default function LocationCardPreview(props: LocationCardPreviewProps) {
    const {
        primary_color,
        location
    } = props
    const [is_active, toggleActive] = useState<boolean>(false)
    const line_2 = []
    if (location.city) line_2.push(location.city)
    if (location.state) line_2.push(location.state)
    if (location.zip) {
        if (line_2.length > 0) {
            line_2[line_2.length - 1] = [
                line_2[line_2.length - 1],
                location.zip,
            ].join(' ')
        } else {
            line_2.push(location.zip)
        }
    }
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    return (
        <section
            key={location.id}
            className="flex flex-col shrink-0 w-1/4 p-1 cursor-pointer rounded-tl rounded-br "
            style={{
                backgroundColor: is_active ? primary_color : "#D1D5DB70"
            }}
            onMouseEnter={() => {
                toggleActive(true)
            }}
            onMouseLeave={() => {
                toggleActive(false)
            }}
        >
            <div
                title={location.name}
                className="text-ellipsis text-[5px] whitespace-nowrap overflow-hidden transition-colors mb-1"
                style={{
                    color: is_active ? "white" : "black"
                }}
            >
                {location.name}
            </div>
            <div className="h-7 rounded-[1px] w-full bg-slate-600/30 items-center text-center justify-center flex v-center focus:outline-none">
                <div className="relative w-full">
                    <img
                        className="h-7 rounded-[1px] w-full object-cover blur-[2px]"
                        src={
                            location.image_url ||
                            `https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/location/location_fallback.jpg`
                        }
                        alt="Location Image"
                    />
                    <img
                        className="h-7 rounded-[1px] w-[98%] object-contain top-0 absolute"
                        src={
                            location.image_url ||
                            `https://${NEXT_PUBLIC_STATIC_DOMAIN}/images/location/location_fallback.jpg`
                        }
                        alt="Location Image"
                    />
                </div>
            </div>
            <address
                className={`transition-colors not-italic text-[3px] leading-[4px] mt-0.5`}
                style={{
                    color: is_active ? "white" : "rgb(75 85 99)"
                }}
            >
                {location.street_1}
                <br />
                {line_2.join(', ')}
                <br />
                {location.country}
            </address>
        </section>
    )
}